<template>
  <div class="column is-6">
    <div class="box">
      <article class="media">
        <figure class="media-left">
          <figure class="image is-128x128">
            <img src="https://bulma.io/images/placeholders/128x128.png">
          </figure>
        </figure>

        <div class="media-content">
          <div class="content">
            <p class="title">{{ car.make }} {{ car.model }}</p>
          </div>
          <aside class="menu">
            <ul class="menu-list">
              <li>
                <router-link :to="{ name: 'gas', params: { id: car.id } }">
                  Gas
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'expenses', params: { id: car.id } }">
                  Expenses
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'statistics', params: { id: car.id } }">
                  Statistics
                </router-link>
              </li>
              <li>
                <a href="" @click.prevent="isEditFormOpened = true">Edit</a>
              </li>
            </ul>
          </aside>

          <div class="content"  v-if="isEditFormOpened === true">
            <div class="field">
              <label class="label">Make</label>
              <input
                type="text"
                class="input"
                v-model="$v.car.make.$model"
                placeholder="Make"
                v-bind:class="{'is-danger': $v.car.make.$error}"
              >
              <p v-if="$v.car.make.$error" class="help is-danger">This value is invalid</p>
            </div>

            <div class="field">
              <label class="label">Model</label>
              <input
                type="text"
                class="input"
                v-model="$v.car.model.$model"
                placeholder="Model"
                v-bind:class="{'is-danger': $v.car.model.$error}"
              >
              <p v-if="$v.car.model.$error" class="help is-danger">This value is invalid</p>
            </div>

            <div class="field">
              <label class="label">Manufacturing Year</label>
              <input
                type="text"
                class="input"
                v-model="$v.car.year.$model"
                placeholder="Manufacturing Year"
                v-bind:class="{'is-danger': $v.car.year.$error}"
              >
              <p v-if="$v.car.year.$error" class="help is-danger">This value is invalid</p>
            </div>

            <div class="field">
              <label class="label">
                Odometer at Purchase
              </label>
              <input
                type="text"
                class="input"
                v-model="$v.car.odometer.$model"
                placeholder="Odometer at Purchase"
                v-bind:class="{'is-danger': $v.car.odometer.$error}"
              >
              <p v-if="$v.car.odometer.$error" class="help is-danger">This value is invalid</p>
            </div>

            <div class="field">
              <button class="button is-primary" @click="updateCar" :disabled="$v.$invalid">
                Save
              </button>

              <button class="button is-danger" @click="cancelEdit">
                Cancel
              </button>

              <button class="button is-danger" @click="deleteCar">
                Delete
              </button>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { required, alphaNum, integer } from 'vuelidate/lib/validators';
import UPDATE_CAR from '@/graphql/cars/updateCar.gql';
import DELETE_CAR from '@/graphql/cars/deleteCar.gql';

export default {
  name: 'CarCard',
  props: [
    'initialCar',
  ],
  data() {
    return {
      car: this.initialCar,
      isEditFormOpened: false,
    };
  },
  validations: {
    car: {
      make: {
        required,
        alphaNum,
      },
      model: {
        required,
        alphaNum,
      },
      year: {
        required,
        integer,
      },
      // image: {},
      odometer: {
        required,
        integer,
      },
    },
  },
  methods: {
    updateCar() {
      this.$apollo.mutate({
        mutation: UPDATE_CAR,
        variables: {
          id: this.car.id,
          make: this.car.make,
          model: this.car.model,
          year: this.car.year,
          odometer: this.car.odometer,
        },
      })
        .then((res) => {
          this.car = res.data.updateCar;
          this.isEditFormOpened = false;
          this.$emit('refetch-list');
          this.$toasted.success(`${this.car.make} ${this.car.model} updated!`);
        })
        .catch((err) => {
          this.$toasted.error(err);
          this.$emit('refetch-list');
        });
    },

    cancelEdit() {
      this.$emit('refetch-list');
      this.isEditFormOpened = false;
    },

    deleteCar() {
      this.$root.$confirm.open(
        `Delete ${this.car.make} ${this.car.model}?`,
        "This action can't be reverted, are you sure?",
      ).then((confirm) => {
        if (confirm) {
          this.$apollo.mutate({
            mutation: DELETE_CAR,
            variables: {
              id: this.car.id,
            },
          })
            .then((res) => {
              this.$emit('refetch-list');
              this.car = res.data.deleteCar;
              this.$toasted.success(`${this.car.make} ${this.car.model} Deleted!`);
            })
            .catch((err) => {
              this.$toasted.error(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
